export default "__VITE_ASSET__BGuIQJTG__"